import { setSpecificMessage, ulid } from "valibot";
setSpecificMessage(
  ulid,
  (issue) => `ULID invalide: reçu ${issue.received}`,
  "fr"
);